import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { useMutation } from '@apollo/react-hooks';
import { useEffect } from 'react';
import { useAsyncFn, useLatest } from 'react-use';
import { REFERRAL_CAMPAIGN_CODE } from '../../constants/promotion';
import { GET_OR_CREATE_REFERRAL_COUPON } from '../../graphql/promotion';
const useReferralCouponCode = ({
  skip,
  onUnexpectedError
}) => {
  const onUnexpectedErrorRef = useLatest(onUnexpectedError);
  const [getOrCreate] = useMutation(GET_OR_CREATE_REFERRAL_COUPON);
  const [state, run] = useAsyncFn(function () {
    var _ref = _asyncToGenerator(function* (shouldSkip) {
      if (shouldSkip) {
        return undefined;
      }
      try {
        var _data$createReferralC, _data$createReferralC2;
        const {
          data
        } = yield getOrCreate({
          variables: {
            input: {
              campaign_code: REFERRAL_CAMPAIGN_CODE
            }
          }
        });
        return (data === null || data === void 0 ? void 0 : (_data$createReferralC = data.createReferralCoupon) === null || _data$createReferralC === void 0 ? void 0 : (_data$createReferralC2 = _data$createReferralC.coupon) === null || _data$createReferralC2 === void 0 ? void 0 : _data$createReferralC2.code) || undefined;
      } catch (error) {
        var _networkError, _networkError$result;
        const code = error === null || error === void 0 ? void 0 : (_networkError = error.networkError) === null || _networkError === void 0 ? void 0 : (_networkError$result = _networkError.result) === null || _networkError$result === void 0 ? void 0 : _networkError$result.code;
        if (!['invalid_referrer', 'campaign_not_effective', 'no_referral_coupon_created'].includes(code !== null && code !== void 0 ? code : '')) {
          var _onUnexpectedErrorRef;
          (_onUnexpectedErrorRef = onUnexpectedErrorRef.current) === null || _onUnexpectedErrorRef === void 0 ? void 0 : _onUnexpectedErrorRef.call(onUnexpectedErrorRef, error);
        }
        return undefined;
      }
    });
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [getOrCreate, onUnexpectedErrorRef]);
  useEffect(() => {
    run(skip);
  }, [run, skip]);
  return [state.value, {
    loading: !skip && state.loading
  }];
};
export default useReferralCouponCode;